export function useWasIntroTriggered() {
  const wasIntroTriggered: boolean = JSON.parse(
    localStorage.getItem("projecttool-intro-triggered") || "false"
  );

  function setWasIntroTriggered() {
    if (!wasIntroTriggered)
      localStorage.setItem("projecttool-intro-triggered", "true");
  }

  return { wasIntroTriggered, setWasIntroTriggered };
}
